module.exports = __webpack_public_path__ + "img/search.e0cf0153.svg";